import { getNomenclature } from '@/http/nomenclature'

export class NomenclatureService {
  async getNomenclature(name) {
    const { data } = await getNomenclature(name)
    return data
  }
}
